<template>
    <div class="">
        
        <template>
            <the-header />
        </template>

        <div class="site-wrapper-reveal">
            <div class="about-banner-wrap banner-space about-us-bg position-relative">
                <div class="banner-overlay"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 ml-auto mr-auto">
                            <div class="about-banner-content text-center">
                                <h1 class="mb-15 text-white">About Us</h1>
                                <h5 class="font-weight--normal text-white">Proven 15 years’ track record in property management. </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="feature-large-images-wrapper section-space--pt_100">
                <div class="container">    
                    <div class="row">
                        <div class="col-lg-12"> 
                            <div class="section-title-wrap text-center">   
                                <h6 class="section-sub-title mb-8">About us</h6>            
                                <h3 class="heading">Axis Realty Property <span class="text-color-primary">Management</span></h3>
                            </div>
                        </div>
                    </div>
                    <div class="cybersecurity-about-text mt-8"> 
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="text">
                                    Partnering with you to provide quality property management services
                                </div>    
                                <div class="text">
                                    Owning a real estate property can be rewarding when you have the right people to help you in its
                                    day to day management. At Axis Realty Property Management, we&#39;ve made a name out of providing
                                    this essential service to investors who lack the time to personally manage their commercial or
                                    residential property. We deal with the nuts and bolts of the business while our clients reap the
                                    rewards of being real estate investors.
                                </div>   
                                <div class="text">   
                                    Having been in the property management business for more than 15 years, overseeing a portfolio of
                                    more than 500 properties in the St. Louis area, we have what it takes to help you manage your real
                                    estate property in this great city. Over this period, we have learned the ins and outs of the business
                                    and are more than capable of helping you take advantage of the many investment opportunities
                                    available in the sector.
                                </div>      
                                <div class="text">   
                                    As a full-service Real Estate Company, we provide specialized services in Property Management,
                                    Investment Property Services, and Home Sales, meaning that whatever challenges you face while
                                    overseeing your properties, we have the solutions to address them.
                                </div>     
                                <div class="text">  
                                    We have a team of highly trained and dedicated staff who personally attend to your real estate
                                    management needs. By using in-house solutions, as opposed to outsourcing aspects of property
                                    management, we ensure that our service charges remain reasonable, helping you manage your
                                    bottom line. 
                                </div>     
                                <div class="text"> 
                                    Our promise is to offer high quality and affordable property management services so that you can
                                    focus on other aspects of your business, like expanding your real estate portfolio. We work the
                                    smart way using novel real estate management tools to help us deliver quality services efficiently.  
                                </div>     
                                <div class="text">   
                                    Whether you are looking to lease, purchase, or develop real estate properties in St. Louis, we have
                                    the expertise to guide you and help you grow your real estate portfolio.
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cta-image-area_one section-space--ptb_80 cta-bg-image_one">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-xl-8 col-lg-7">
                            <div class="cta-content md-text-center">
                                <h3 class="heading text-white">Call or email us today, so we can talk real estate  <span class="text-color-secondary"> business.</span></h3>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-5">
                            <div class="cta-button-group--one text-center">
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

        </div>
            
        <the-footer />
    </div>
</template>

<script>
import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter   from '@/layouts/components/TheFooter.vue'

export default {
  components: {
    TheHeader,
    TheFooter
  },
  data () {
    return {
    }
  }

}
</script>